<div class="field w-full">
  @if (label) {
  <label class="block mb-1 {{ labelCustomClass }}">{{ label }}<span class="text-red-500">*</span></label>
  }

  <!-- wrapper: single visible border + real shadow on focus -->
  <div
    class="w-full rounded-md border border-gray-300 focus-within:border-blue-500 transition-all duration-150 shadow-none focus-within:shadow-[0_0_8px_2px_rgba(59,130,246,0.6)] overflow-hidden">
    <p-select [options]="options" [optionLabel]="optionLabel" [optionValue]="optionValue" [placeholder]="placeholder"
      [disabled]="disabled" [(ngModel)]="value" [invalid]="ngControl.invalid && submitted" (onChange)="onSelect($event)"
      class="w-full !p-0 !m-0 {{inputCustomClass}}" appendTo="body" scrollHeight="200px" [filter]="filter"
      [resetFilterOnHide]="true" [virtualScroll]="isVirtualScroll" [virtualScrollOptions]="{
            scrollHeight: '200px',
            itemSize: 32,
            numToleratedItems: 5,
            delay: 0,
            lazy: false,
            showLoader: false}" [group]="group" [optionGroupLabel]="optionGroupLabel"
      [optionGroupChildren]="optionGroupChildren">

      <ng-template #selectedItem let-selectedOption>
        <ng-container *ngIf="selectedOption">
          @if (selectedItemTemplate) {
          <ng-container
            *ngTemplateOutlet="selectedItemTemplate; context: {$implicit: getSelectedOption(selectedOption)}"></ng-container>
          } @else {
          {{ selectedOption[optionLabel] || selectedOption }}
          }
        </ng-container>
      </ng-template>

      <ng-template #item let-item>
        <ng-container *ngIf="itemTemplate">
          <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
        </ng-container>
        <ng-container *ngIf="!itemTemplate">
          {{ item[optionLabel] }}
        </ng-container>
      </ng-template>

    </p-select>
  </div>

  <small [appFormErrorMessageDirective]="ngControl.control" [submitted]="submitted"> </small>
</div>